export default __webpack_public_path__ + "static/media/cuidadosdiarios.10b2498e.webp";